import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { AxiosResponseAndError,ResponseType } from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type RiskDuplicateResponseType = ResponseType<null>;
function useRiskDuplicateMutation() {

  const mutation = useMutation<
    AxiosResponseAndError<RiskDuplicateResponseType>["response"],
    AxiosResponseAndError<RiskDuplicateResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.put<RiskDuplicateResponseType>(
        `${requestURLs.risk}duplicate-risk/${data}`,
        data
      ),
  });

  return mutation;
}
export default useRiskDuplicateMutation;
